import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions as measurementActions } from 'ducks/measurements';
import React from 'react';
import { useSelector } from 'react-redux';
import { metadataFields, serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getMeasurementMetadata } from 'utils/getMetadata.js';

const Component = props => {
    const { device, measurement } = props;
    const { closeDrawer } = props;

    const formSchema = [];

    const equipment = useSelector(state => state.equipments.models[device.equipment_id]);
    const submitting = useSelector(state => state.measurements.submitting);

    const rootDevice = useSelector(state => state.devices.models[device.root_device_id]);
    const metadata = getMeasurementMetadata(device, rootDevice);

    if (['wise_input', 'wise_current'].includes(equipment.equipment_category_slug) || equipment.equipment_type_slug === 'input_sensor') {
        formSchema.push({
            label: 'Name\x2a',
            name: 'name',
            type: 'text',
            validate: [validators.required]
        });
    }

    formSchema.push(...metadataFields(metadata, measurement));

    const update = measurementActions.useUpdate();
    const onSubmit = values => {
        update(
            measurement.id,
            serializeForm(values, formSchema, measurement),
            closeDrawer
        );
    };

    return (
        <FormViewer label="Edit Measurement">
            <Form
                formInitialValues={measurement}
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
